<template>
    <div class="notfound">
        <h1>Page not found</h1>
        <p><router-link to="/">Home</router-link></p>
    </div>
</template>